import { useForm } from 'react-hook-form';
import { useUser } from '../../../contexts/UserContext';
// import { Button } from '../../buttons/Button';
import { postUserLogin } from '../../../services/entity/user/user-api';
import { HeadForm } from '../AuthForm';
// import { GoogleLoginButton } from '../../buttons/GoogleLoginButton';
// import { generateRandomString } from '../../../helpers/common/generateRandomString';
import { getClientLogoUrl } from "../../../helpers/common/clientLogo";
import { useEffect, useState } from "react";

export const LoginForm = ({ setIsFormLoading, setIsAuth, setIsForgotPassword }) => {
  const {
    handleSubmit,
    formState: { errors },
    setError,
    register,
  } = useForm();

  const { updateUser } = useUser();

  // const randomStreamId = generateRandomString(5);
  const [clientLogoUrl, setClientLogoUrl] = useState(null);

  const ssoMode = process.env.REACT_APP_SSO_MODE?.trim().toLowerCase();
  const isSamlV2Enabled = ssoMode === 'samlv2';

  const onSubmit = async (data) => {
    try {
      setIsFormLoading(true);
      let userData = await postUserLogin({
        email: data.email,
        password: data.password,
      });
      if (userData) {
        updateUser(userData);
        window.location.reload();
      }
    } catch (error) {
      if (error.response.status === 404) {
        setError('email', {
          type: 'manual',
          message: 'Invalid email',
        });
      } else if (error.response.status === 401) {
        setError('password', {
          type: 'manual',
          message: 'Invalid password',
        });
      } else {
        setError('email', {
          type: 'manual',
          message: 'Something bad happened...',
        });
      }
    } finally {
      setIsFormLoading(false);
    }
  };

  const handleSsoLogin = () => {
    switch (ssoMode) {
      case 'samlv2': {
        const samlLoginUrl = process.env.REACT_APP_API_ADDRESS.replace(/api\/?$/, 'saml/login');

        setIsFormLoading(true);
        window.location.href = samlLoginUrl;
        break;
      }

      default:
        break;
    }
  };

  useEffect(() => {
    const fetchLogo = async () => {
      setClientLogoUrl(await getClientLogoUrl());
    };
    fetchLogo();
  }, []);

  return (
    <div className='w-full h-full justify-center flex flex-col'>
      {clientLogoUrl && (
        <div className='flex justify-center h-[100px] mb-8'>
          <img src={clientLogoUrl} alt='Client Logo' className='h-full w-auto max-w-full' />
        </div>
      )}

      <HeadForm title='Connexion' />

      <form className='flex flex-col justify-start item-center mt-6' onSubmit={handleSubmit(onSubmit)}>
        <div className='flex flex-col mb-4'>
          <label htmlFor='email' className='mb-1 text-xs font-semibold uppercase tracking-wider text-gray-600'>
            Email
          </label>

          <input
            id='email'
            type='email'
            placeholder='Email'
            autoComplete='email'
            {...register('email')}
            className={`w-full h-12 px-4 rounded-xl border bg-white text-sm outline-none transition-all duration-200 ${
              errors.email ? 'border-red-500' : 'border-gray-300'
            } focus:border-perception-blue focus:ring-1 focus:ring-perception-blue`}
          />

          {errors.email && (
            <span className='mt-1 text-xs text-red-500'>
              {errors.email.message}
            </span>
          )}
        </div>

        <div className='flex flex-col mb-5'>
          <label htmlFor='password' className='mb-1 text-xs font-semibold uppercase tracking-wider text-gray-600'>
            Password
          </label>

          <input
            id='password'
            type='password'
            placeholder='Password'
            autoComplete='current-password'
            {...register('password')}
            className={`w-full h-12 px-4 rounded-xl border bg-white text-sm outline-none transition-all duration-200 ${
              errors.password ? 'border-red-500' : 'border-gray-300'
            } focus:border-perception-blue focus:ring-1 focus:ring-perception-blue`}
          />

          {errors.password && (
            <span className='mt-1 text-xs text-red-500'>
              {errors.password.message}
            </span>
          )}
        </div>

        {/*
        <div className='flex items-center justify-between w-full py-2'>
          <span
            className='w-full text-center text-xs text-perception-blue cursor-pointer mt-2'
            onClick={() => setIsAuth(false)}
          >
            Don&apos;t have an account?
          </span>
          <span
            className='w-full text-center text-xs text-perception-blue cursor-pointer mt-2'
            onClick={() => setIsForgotPassword(true)}
          >
            Forgot password
          </span>
        </div>
        */}

        <div className='flex flex-col justify-center items-center gap-3 mt-3'>
          <button
            className='w-full h-12 rounded-md bg-perception-blue text-white font-semibold transition-opacity duration-200 hover:opacity-90'
            type='submit'
          >
            Log in
          </button>

          {isSamlV2Enabled && (
            <button
              className='w-full h-12 rounded-md bg-black text-white font-semibold transition-opacity duration-200 hover:opacity-80'
              type='button'
              onClick={handleSsoLogin}
            >
              Log in with SSO
            </button>
          )}

          {/*
          <GoogleLoginButton
            streamId={randomStreamId}
            setIsFormLoading={setIsFormLoading}
          />
          */}
        </div>
      </form>
    </div>
  );
};